import { useCookies } from '@vueuse/integrations/useCookies'
import { ChannelId, TRIVAGO_COOKIE_EXPIRY_DAYS } from '../system/constants/channels'

interface TrivagoParameters {
  trv_reference: string
  trv_locale?: string | null
  trv_CPA?: boolean
}

interface ChannelCallback {
  handle: (query: any, hotelId: string) => void
}

interface ChannelCallbacks {
  [key: string]: ChannelCallback
}

export function useChannelManager() {
  const handleTrivago = (query: any, hotelId: string) => {
    const ref = query.trv_reference
    const locale = query.trv_locale
    const cpa = query.trv_CPA

    if (!ref) {
      return
    }

    const cookies = useCookies([`trivago_params_${hotelId}`])
    const trivagoParams: TrivagoParameters = {
      trv_reference: ref,
      trv_locale: locale || null,
      trv_CPA: cpa || null,
    }

    const expiryDate = new Date()
    expiryDate.setDate(expiryDate.getDate() + TRIVAGO_COOKIE_EXPIRY_DAYS)

    cookies.set(`trivago_params_${hotelId}`, trivagoParams, {
      expires: expiryDate,
      path: '/'
    })
  }

  const handleChannelCallback = (channelId: ChannelId, query: any, hotelId: string = ''): void => {
    const channel = channelsCallbacks[channelId]
    if (channel === undefined) {
      return
    }

    channel.handle(query, hotelId)
  }

  const clearTrivagoParams = (hotelId: string) => {
    const cookies = useCookies([`trivago_params_${hotelId}`])
    cookies.remove(`trivago_params_${hotelId}`)
  }

  const channelsCallbacks: ChannelCallbacks = {
    [ChannelId.DEFAULT]: {
      handle: () => { },
    },
    [ChannelId.DIGIBOOKING]: {
      handle: () => { },
    },
    [ChannelId.TRIP_ADVISOR]: {
      handle: () => { },
    },
    [ChannelId.GOOGLE_HOTEL_ADS]: {
      handle: () => { },
    },
    [ChannelId.TRIVAGO]: {
      handle: handleTrivago,
    },
    [ChannelId.KAYAK]: {
      handle: () => { },
    },
    [ChannelId.SPIDERMETA]: {
      handle: () => { },
    },
    [ChannelId.KINDERHOTELINFO]: {
      handle: () => { },
    },
    [ChannelId.HUNDEHOTELINFO]: {
      handle: () => { },
    },
    [ChannelId.HOTELSSALZBURGINFO]: {
      handle: () => { },
    },
    [ChannelId.SUPERIORHOTELSINFO]: {
      handle: () => { },
    },
    [ChannelId.FERIENPENSIONENINFO]: {
      handle: () => { },
    },
    [ChannelId.PISTENHOTELSINFO]: {
      handle: () => { },
    },
    [ChannelId.DIALOGSHIFT]: {
      handle: () => { },
    },
  }

  const isOwnChannel = (channelId: ChannelId): boolean =>
    channelId === ChannelId.DEFAULT

  return {
    isOwnChannel,
    handleChannelCallback,
    clearTrivagoParams
  }
}
